export default __webpack_public_path__ + "static/gif-4c73d029e7c62cf2d379686d0efa730f.gif";